export default __webpack_public_path__ + "static/media/timer_s2.a084a01c.png";